/**
 * @file Contains hook for opening the compose if the compose form is minimized at first render
 */
import { useLayoutEffect } from 'react';

import {
  NavigationType,
  useLocation,
  useNavigate,
  useNavigationType,
} from 'react-router-dom';

import useIsComposeMinimized from '../../../hooks/router/search/useIsComposeMinimized';
import { getComposeMinimizeToggleUrl } from '../../../routes/urls/searchParams/compose';

/**
 * Hook that opens the compose if the compose form is minimized at first render
 */
const useComposeMinimize = () => {
  const isMinimized = useIsComposeMinimized();
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (isMinimized) {
      // Maximize the compose form if it's direct link or reload
      if (navigationType === NavigationType.Pop) {
        navigate(getComposeMinimizeToggleUrl(location));
      }
    }
    // We want to maximize the compose form only on the first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useComposeMinimize;
